import { persistReducer } from './persist-reducer.util'
export { useWindowSize } from './useWindowSize'
export { useWidth } from './useWidth' // similar to 'useWindowSize' but with material-ui theme breakpoints
export { useDidUpdateEffect } from './useDidUpdateEffect'
export * from './fileUtils'
export * from './pwdUtils'
export * from './browserUtils'
export * from './dateUtils'
export * from './comboUtils'
export * from './idDocValidation'
export * from './mailValidation'
export * from './commonUtils'
export * from './feedbackUtils'
export { renderLoading } from './render-loading.util'
export { loadLocalStorage, saveLocalStorage } from './localStorage'
export * from './parseDataString'
export * from './tabSession'

export const usePersistReducer = persistReducer()
